"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BaseControl =
/*#__PURE__*/
function () {
  function BaseControl(props) {
    _classCallCheck(this, BaseControl);

    this._id = props._id;
    this.$_element = $("<div id='field-container-".concat(this._id, "' class=\"d5-field\"/>"));
    this.value = props.value;
    this.props = props;
    this.component = '';
  }

  _createClass(BaseControl, [{
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this = this;

      return {
        value: this.value,
        disabled: this.props.disabled || false,
        visible: this.props.visible || true,
        onKeyDown: function onKeyDown(e) {
          if (typeof _this.props.onKeyDown === 'function') {
            setTimeout(function () {
              _this.props.onKeyDown(e);
            }, 100);
          }
        },
        onValueChanged: function onValueChanged(e) {
          if (typeof _this.props.onValueChanged === 'function') {
            _this.props.onValueChanged(e);
          }
        }
      };
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "instance",
    value: function instance() {
      throw new Error('Must be implemented in a child');
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      this.value = newValue;
      this.instance().option('value', this.value);
    }
  }, {
    key: "render",
    value: function render() {
      throw new Error('Must be implemented in a child');
    }
  }, {
    key: "dispose",
    value: function dispose() {
      throw new Error('Must be implemented in a child');
    }
  }, {
    key: "element",
    value: function element() {
      return this.$_element;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.instance().option('disabled');
    },
    set: function set(disabled) {
      this.instance().option('disabled', disabled);
    }
  }, {
    key: "visible",
    get: function get() {
      return this.instance().option('disabled');
    },
    set: function set(visible) {
      this.instance().option('visible', visible);
    }
  }, {
    key: "dataSource",
    get: function get() {
      return this.instance().option('dataSource');
    },
    set: function set(dataSource) {
      this.instance().option('dataSource', dataSource);
      this.dataSource.reload();
    }
  }]);

  return BaseControl;
}();

export { BaseControl as default };